<template>
    <b-modal ref="mdlAachenerAphasieTest" :title="titoloModale" size="xl" centered scrollable no-close-on-backdrop no-close-on-esc :hide-header-close="isSaving" @shown="onShown" @hidden="onHidden">
        <fieldset :disabled="isSaving">
            <rsa-scheda-aachener-aphasie-test-edit-component v-if="isOpen" ref="cmpAachenerAphasieTestEdit" :isReadOnly="isModalView" @update="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></rsa-scheda-aachener-aphasie-test-edit-component>
        </fieldset>
        <template #modal-footer>
            <b-button v-if="isModalView" variant="outline-primary" @click="onClickOk">Ok</b-button>
            <template v-else>
                <b-button variant="outline-danger" :disabled="isSaving" @click="onClickUndo">Annulla</b-button>
                <b-button variant="outline-success" :disabled="isSaving || !jsonDataReady" @click="onSalvaAachenerAphasieTest">Salva</b-button>
            </template>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
import RsaSchedaAachenerAphasieTestEditComponent from "./RsaSchedaAachenerAphasieTestEditComponent.vue";

export default {
    name: "RsaPazienteSchedaAachenerAphasieTestModalEdit",
    components: { ModalError, RsaSchedaAachenerAphasieTestEditComponent },
    data() {
        return {
            idAccettazione: null,
            idRisorsa: null,
            pathResource: "/aacheneraphasietest",
            isModalView: false,
            isOpen: false,
            isSaving: false,
            jsonDataReady: false,
            jsonData: {},
        };
    },
    computed: {
        titoloModale() {
            if (this.isModalView) return "Visualizzazione Aachener Aphasie Test";
            return this.idRisorsa ? "Modifica Aachener Aphasie Test" : "Nuovo Aachener Aphasie Test";
        },
    },
    methods: {
        show(idAccettazione) {
            this.openModal(idAccettazione, null, false);
        },
        visualizzaScheda(item, idAccettazione) {
            this.openModal(idAccettazione, item.id, true);
        },
        modificaScheda(item, idAccettazione) {
            this.openModal(idAccettazione, item.id, false);
        },
        openModal(idAccettazione, idRisorsa, isModalView) {
            this.idAccettazione = idAccettazione;
            this.idRisorsa = idRisorsa;
            this.isModalView = isModalView;
            this.jsonData = {};
            this.jsonDataReady = false;
            this.isOpen = true;
            this.$refs.mdlAachenerAphasieTest.show();
        },
        onShown() {
            this.$refs.cmpAachenerAphasieTestEdit.init(this.idAccettazione, this.idRisorsa);
        },
        onUpdateJsonData(data) {
            this.jsonData = data;
            this.jsonDataReady = this.$refs.cmpAachenerAphasieTestEdit.jsonDataReady;
        },
        onBeforeLoadData() {
            this.$emit("beforeLoadData");
        },
        onAfterLoadData() {
            let component = this.$refs.cmpAachenerAphasieTestEdit;
            this.jsonDataReady = component.jsonDataReady;
            if (this.jsonDataReady) this.jsonData = component.jsonData;
            this.$emit("afterLoadData");
        },
        onSalvaAachenerAphasieTest() {
            if (this.isModalView || this.isSaving || !this.jsonDataReady) return;
            let me = this;
            let payload;
            try {
                if (!me.jsonData.idAccettazione) throw new Error("Accettazione non specificata");
                payload = me.$refs.cmpAachenerAphasieTestEdit.getJsonData();
            } catch (error) {
                me.$refs.cmpModalError.show(error.message);
                return;
            }
            me.isSaving = true;
            me.$emit("beforeLoadData");
            UtilityMixin.methods.saveResource(me.pathResource, payload, me.resultSaveResponse, me.resultSaveError);
        },
        resultSaveResponse(response) {
            let me = this;
            if (response.data.esito === false) {
                me.resultSaveError(new Error(response.data.messaggio || "Errore nel salvataggio della scheda"));
                return;
            }
            me.isSaving = false;
            me.$emit("afterLoadData");
            me.$emit("afterSave");
            me.$refs.mdlAachenerAphasieTest.hide();
        },
        resultSaveError(error) {
            let me = this;
            me.isSaving = false;
            me.$emit("afterLoadData");
            let messaggio = error.response && error.response.data && error.response.data.messaggio ? error.response.data.messaggio : error.message;
            me.$refs.cmpModalError.show(messaggio || "Errore nel salvataggio della scheda");
        },
        onClickUndo() {
            this.$refs.mdlAachenerAphasieTest.hide();
        },
        onClickOk() {
            this.$refs.mdlAachenerAphasieTest.hide();
        },
        onHidden() {
            this.isOpen = false;
            this.isModalView = false;
            this.isSaving = false;
            this.jsonDataReady = false;
            this.jsonData = {};
            this.idRisorsa = null;
        },
    },
};
</script>
